// = Libs =
import { FC, SyntheticEvent } from 'react';

// = Styles =
import classes from '../file-uploader.module.scss';

// = Types =
import { FileProps } from '../file-uploader.types';

// = Components =
import Icon from '@/common/components/ui/icon/icon';

const File: FC<FileProps> = (props) => {
  const { name = '', type = 'pdf', onRemove } = props;

  const handleRemove = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    onRemove(name);
  };

  return (
    <li className={classes['file__item']}>
      <div className={classes['file__item-content']}>
        <Icon type={'pdf'} color="dark" className={classes['file__item-icon']} />
        <span className={classes['file__item-name']}>{name}</span>
      </div>
      <div className={classes['file__item-actions']}>
        <div className={classes['file__item-remove']} onClick={handleRemove}>
          <Icon type="basket" />
        </div>
      </div>
    </li>
  );
};

export default File;
